import { useState } from 'react';
import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const heroImage =
  'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20hero%20banner%20illustration%20of%20a%20determined%20young%20hero%20standing%20on%20shattered%20city%20street%2C%20enormous%20orange%20explosion%20shockwave%20erupting%20behind%20him%2C%20dramatic%20sky%20filled%20with%20glowing%20embers%20and%20energy%20rings%2C%20bold%20clean%20linework%2C%20cinematic%20wide%20shot%2C%20vibrant%20orange%20amber%20and%20crimson%20color%20grading%2C%20dramatic%20rim%20lighting%2C%20clean%20minimal%20background%20with%20warm%20gradient%20and%20particle%20effects%2C%20high%20quality%20digital%20painting%2C%20epic%20comic%20composition%2C%20no%20text%2C%20no%20watermark&width=1600&height=900&seq=hero-zhalie-bang-01&orientation=landscape';

const stats = [
  { value: '3200+', label: '在库作品' },
  { value: '150+', label: '每日更新' },
  { value: '860万', label: '注册读者' },
  { value: '9.5+', label: '平均评分' },
];

export default function HeroSection() {
  const featured = comics.find((c) => c.isFeatured) ?? comics[0];
  const [shelved, setShelved] = useState(false);

  return (
    <section className="relative -mt-16 w-full overflow-hidden bg-foreground-950 md:-mt-20" aria-label="本周热推漫画">
      <img
        src={heroImage}
        alt="《炸裂吧！巨棒》韩漫人气作品横幅"
        title="《炸裂吧！巨棒》韩漫免费阅读"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/40 to-foreground-950/80" aria-hidden="true"></div>

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:min-h-[640px] md:px-6">
        <span className="flex items-center gap-1.5 rounded-full border border-background-50/30 bg-background-50/10 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur-sm md:px-4 md:text-sm">
          <i className="ri-fire-fill h-4 w-4 text-secondary-500" aria-hidden="true"></i>
          本周热推 · 韩漫人气TOP1
        </span>
        <h1 className="mt-5 font-display text-4xl font-bold leading-tight text-background-50 md:text-6xl">
          《炸裂吧！巨棒》
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-7 text-background-50/90 md:text-base">
          下拉式免费阅读 · 韩漫无删减 · 更新至{featured.latestChapter}。平凡少年觉醒炸裂之力，一拳引爆都市异能世界！在57漫画网高清畅读。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-5 text-xs text-background-50/90 md:gap-8 md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-star-fill h-4 w-4 text-secondary-500" aria-hidden="true"></i>
            <strong className="font-bold text-secondary-400">{featured.rating}分</strong>
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-eye-line h-4 w-4" aria-hidden="true"></i>
            点击 {featured.views}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-archive-line h-4 w-4" aria-hidden="true"></i>
            共 {featured.chapters} 话
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line h-4 w-4" aria-hidden="true"></i>
            {featured.updatedAt} 更新
          </span>
        </div>
        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to={`/comic/${featured.id}`}
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-8 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto md:px-10 md:py-3.5 md:text-base"
          >
            <i className="ri-book-open-line h-5 w-5" aria-hidden="true"></i>
            立即开始阅读
          </Link>
          <button
            type="button"
            onClick={() => setShelved((v) => !v)}
            className={`flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg border px-8 py-3 text-sm font-bold transition-colors sm:w-auto md:px-10 md:py-3.5 md:text-base ${
              shelved
                ? 'border-secondary-400 bg-secondary-500/20 text-secondary-400'
                : 'border-background-50/40 text-background-50 hover:bg-background-50/10'
            }`}
          >
            <i className={`${shelved ? 'ri-bookmark-fill' : 'ri-bookmark-line'} h-5 w-5`} aria-hidden="true"></i>
            {shelved ? '已加入书架' : '加入书架'}
          </button>
          <Link
            to="/category"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg px-8 py-3 text-sm font-bold text-background-50/85 underline-offset-4 transition-colors hover:text-background-50 hover:underline sm:w-auto md:px-8 md:py-3.5 md:text-base"
          >
            浏览全部分类
            <i className="ri-arrow-right-line h-5 w-5" aria-hidden="true"></i>
          </Link>
        </div>
      </div>

      <div className="relative border-t border-background-50/15 bg-foreground-950/60 backdrop-blur-sm">
        <dl className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-4 px-4 py-5 md:grid-cols-4 md:px-6 md:py-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <dt className="order-2 mt-1 text-[11px] text-background-50/70 md:text-xs">{s.label}</dt>
              <dd className="font-display text-xl font-bold text-secondary-400 md:text-2xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}